<template>
  <v-container class="main-template" fluid>
    <v-text-field
      v-model="search"
      label="Search Settings"
      prepend-inner-icon="mdi-magnify"
      class="ma-4"
      clearable
      hide-details
      dense
    />
    <!-- <div style="height: 90vw;overflow-y: auto;"> -->
    <div v-for="(group, groupName) in groupedSettings" :key="groupName">
      <h3 class="mb-4 ml-3">{{ groupName }}</h3>
      <v-row class="px-4" dense>
        <v-col v-for="item in group" :key="item.text" cols="12" sm="6" md="4" lg="3" xl="2">
          <v-card
            v-if="!search || item.description.includes(search) || item.text.includes(search)"
            class="pa-4 text-center"
            @click="addToTab(item)"
            :to="item.link"
            link
            hover
            outlined
          >
            <v-icon size="48" class="mb-2">{{ item.icon }}</v-icon>
            <div class="font-weight-medium text-subtitle-1">
              {{ item.text }}
            </div>
            <div class="text-caption grey--text">{{ item.description }}</div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <!-- </div> -->
  </v-container>
</template>

<script>
import axios from "axios";
import * as fun from "../plugins/common";
export default {
  name: "SettingsMenu",
  components: {
    DTable: () => import("../components/Table.vue")
  },
  props: {},
  data() {
    return {
      dataReady: false,
      search: "",
      data_object: {
        db_name: "admin",

        object_name: "settings_menu",
        all_records: true
      },
      settings: []
      //   tableReady: true,
      //   tableName: "Settings Menu",
      //   addButtonCaption: "Add Menu Item",
    };
  },
  computed: {
    groupedSettings() {
      return this.settings.reduce((acc, item) => {
        const group = item.group || "Other";
        if (!acc[group]) acc[group] = [];
        acc[group].push(item);
        return acc;
      }, {});
    }
  },
  mounted() {
    var that = this;
    axios
      .post(this.serverURL + "/get_data", this.data_object, {
        withCredentials: true
      })
      .then(function(response) {
        that.settings = response.data.model;
        that.dataReady = true;
      });
  },

  beforeDestroy() {},
  methods: {
    addToTab(m) {
      this.$root.addResentTab(m);
    }
  }
};
</script>

<style lang="css" scoped></style>
